import Button from 'components/form/Button';
import DatePicker from 'components/form/DatePicker';
import TextInput from 'components/form/TextInput';
import React from 'react';
// Publication Details Few slots left
const ThirdStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values, setFieldValue } = props;
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    props;

  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    paper_title,
    journals,
    isbn_number,
    your_name,
    contact_details,
  } = values;

  const addJournal = () => {
    setFieldValue('journals', [
      ...journals,
      {
        journal_name: '',
      },
    ]);
  };

  // Function to remove a speaker by index
  const removeSpeaker = (index) => {
    const newJournals = journals?.filter((_, i) => i !== index);
    setFieldValue('journals', newJournals);
  };

  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Paper Title
        </div>
        <div className="col-lg-6">
          <TextInput
            id="paper_title"
            onChange={handleChange}
            value={paper_title}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.paper_title && errors.paper_title}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={
              touched.conference_short_name && errors.conference_short_name
            }
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference From Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_from_date"
            onChange={handleChange}
            value={conference_from_date}
            disabled={!isEdit}
            error={errors.conference_from_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference To Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_to_date"
            onChange={handleChange}
            value={conference_to_date}
            disabled={!isEdit}
            error={errors.conference_to_date}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Venue
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>

      <div className="speakers-container">
        <div className="d-flex align-items-center gap-3">
          <h5>Journals</h5>
          <div className="d-flex">
            <Button
              isSquare
              text="+ Add Journal"
              btnStyle="primary-light"
              className={'h-35 '}
              onClick={addJournal}
              disabled={!isEdit}
            />
          </div>
        </div>
        {journals?.map((journal, index) => (
          <div key={index} className="speaker-fields">
            <div className="d-flex align-items-center flex-wrap cmb-19">
              <div className="color-black-olive text-14-400-17 col-lg-6">
                Journal {index + 1}
              </div>
              <div className="col-lg-6">
                <TextInput
                  id={`journals[${index}].journal_name`}
                  onChange={handleChange}
                  value={journal.journal_name}
                  disabled={!isEdit}
                  suggestions={suggestionData?.journal_name}
                  onBlur={handleBlur}
                  error={
                    touched?.journals?.[index]?.journal_name &&
                    errors?.journals?.[index]?.journal_name
                  }
                />
              </div>
            </div>

            {journals?.length > 1 && journals?.length - 1 === index && (
              <div className="d-flex">
                <Button
                  isSquare
                  text="Delete"
                  btnStyle="primary-gray"
                  icon={<i className="bi bi-trash me-2" />}
                  className="cpt-5 cpb-5 cps-10 cpe-10 h-35"
                  onClick={() => {
                    removeSpeaker(index);
                  }}
                  disabled={!isEdit}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          ISBN Number
        </div>
        <div className="col-lg-6">
          <TextInput
            id="isbn_number"
            onChange={handleChange}
            value={isbn_number}
            disabled={!isEdit}
            suggestions={suggestionData?.isbn_number}
            onBlur={handleBlur}
            error={touched.isbn_number && errors.isbn_number}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>

      {/* <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_link"
            onChange={handleChange}
            value={registration_link}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_link}
          />
        </div>
      </div> */}
    </>
  );
};

export default ThirdStepOfFollowUps;
